/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ListItemTypeEnum = "containers" | "external_contacts" | "internal_contacts" | "item" | "messages" | "shipments" | "tickets" | "vessels" | "voyages" | "%future added value";
export type FilterInput = {
    key: string;
    values: Array<string>;
};
export type ItemListFiltersQueryVariables = {
    searchQuery?: string | null;
    type?: ListItemTypeEnum | null;
    filters?: Array<FilterInput> | null;
    handoverDateStart?: string | null;
    handoverDateEnd?: string | null;
    voyageEtaStart?: string | null;
    voyageEtaEnd?: string | null;
    voyageEtdStart?: string | null;
    voyageEtdEnd?: string | null;
    dischargeDateStart?: string | null;
    dischargeDateEnd?: string | null;
    contactSlug?: string | null;
    includeArchived?: boolean | null;
    sharedContactType?: string | null;
    parentAbsoluteSlug?: string | null;
};
export type ItemListFiltersQueryResponse = {
    readonly filterList: {
        readonly " $fragmentRefs": FragmentRefs<"ItemListFilters_data">;
    };
};
export type ItemListFiltersQuery = {
    readonly response: ItemListFiltersQueryResponse;
    readonly variables: ItemListFiltersQueryVariables;
};



/*
query ItemListFiltersQuery(
  $searchQuery: String
  $type: ListItemTypeEnum
  $filters: [FilterInput!]
  $handoverDateStart: Date
  $handoverDateEnd: Date
  $voyageEtaStart: Date
  $voyageEtaEnd: Date
  $voyageEtdStart: Date
  $voyageEtdEnd: Date
  $dischargeDateStart: Date
  $dischargeDateEnd: Date
  $contactSlug: String
  $includeArchived: Boolean
  $sharedContactType: String
  $parentAbsoluteSlug: String
) {
  filterList(searchQuery: $searchQuery, type: $type, filters: $filters, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, contactSlug: $contactSlug, includeArchived: $includeArchived, sharedContactType: $sharedContactType, parentAbsoluteSlug: $parentAbsoluteSlug) {
    ...ItemListFilters_data
  }
}

fragment ItemListFilters_data on ItemList {
  filters {
    key
    ...ListPageFilter_filter
  }
}

fragment ListPageFilter_filter on Filter {
  key
  name
  values {
    label
    displayLabel
    selected
    ...ListPageFilter_filterValue
  }
}

fragment ListPageFilter_filterValue on FilterValue {
  label
  displayLabel
  selected
  count
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dischargeDateStart"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handoverDateEnd"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handoverDateStart"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentAbsoluteSlug"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sharedContactType"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaEnd"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtaStart"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdEnd"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "voyageEtdStart"
},
v15 = [
  {
    "kind": "Variable",
    "name": "contactSlug",
    "variableName": "contactSlug"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateEnd",
    "variableName": "dischargeDateEnd"
  },
  {
    "kind": "Variable",
    "name": "dischargeDateStart",
    "variableName": "dischargeDateStart"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "handoverDateEnd",
    "variableName": "handoverDateEnd"
  },
  {
    "kind": "Variable",
    "name": "handoverDateStart",
    "variableName": "handoverDateStart"
  },
  {
    "kind": "Variable",
    "name": "includeArchived",
    "variableName": "includeArchived"
  },
  {
    "kind": "Variable",
    "name": "parentAbsoluteSlug",
    "variableName": "parentAbsoluteSlug"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "sharedContactType",
    "variableName": "sharedContactType"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaEnd",
    "variableName": "voyageEtaEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtaStart",
    "variableName": "voyageEtaStart"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdEnd",
    "variableName": "voyageEtdEnd"
  },
  {
    "kind": "Variable",
    "name": "voyageEtdStart",
    "variableName": "voyageEtdStart"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemListFiltersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "filterList",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ItemListFilters_data"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v10/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v12/*: any*/),
      (v11/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ItemListFiltersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "ItemList",
        "kind": "LinkedField",
        "name": "filterList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Filter",
            "kind": "LinkedField",
            "name": "filters",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FilterValue",
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "selected",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8bc8a7c1a6ff5db319110a5e07f6313",
    "id": null,
    "metadata": {},
    "name": "ItemListFiltersQuery",
    "operationKind": "query",
    "text": "query ItemListFiltersQuery(\n  $searchQuery: String\n  $type: ListItemTypeEnum\n  $filters: [FilterInput!]\n  $handoverDateStart: Date\n  $handoverDateEnd: Date\n  $voyageEtaStart: Date\n  $voyageEtaEnd: Date\n  $voyageEtdStart: Date\n  $voyageEtdEnd: Date\n  $dischargeDateStart: Date\n  $dischargeDateEnd: Date\n  $contactSlug: String\n  $includeArchived: Boolean\n  $sharedContactType: String\n  $parentAbsoluteSlug: String\n) {\n  filterList(searchQuery: $searchQuery, type: $type, filters: $filters, handoverDateStart: $handoverDateStart, handoverDateEnd: $handoverDateEnd, voyageEtaStart: $voyageEtaStart, voyageEtaEnd: $voyageEtaEnd, voyageEtdStart: $voyageEtdStart, voyageEtdEnd: $voyageEtdEnd, dischargeDateStart: $dischargeDateStart, dischargeDateEnd: $dischargeDateEnd, contactSlug: $contactSlug, includeArchived: $includeArchived, sharedContactType: $sharedContactType, parentAbsoluteSlug: $parentAbsoluteSlug) {\n    ...ItemListFilters_data\n  }\n}\n\nfragment ItemListFilters_data on ItemList {\n  filters {\n    key\n    ...ListPageFilter_filter\n  }\n}\n\nfragment ListPageFilter_filter on Filter {\n  key\n  name\n  values {\n    label\n    displayLabel\n    selected\n    ...ListPageFilter_filterValue\n  }\n}\n\nfragment ListPageFilter_filterValue on FilterValue {\n  label\n  displayLabel\n  selected\n  count\n}\n"
  }
};
})();
(node as any).hash = '184f7ae21bcec1381d7ca7711af333ff';
export default node;
